module.exports = __webpack_public_path__ + "static/img/logo_h.4a7b120c.png";